<script setup lang="ts">
import {PieChartWidget} from "@/laboratory/components/dashboard/dashboard";
import {ArcElement, Chart as ChartJS, Legend, Title, Tooltip} from "chart.js";
import {computed} from "vue";
import ChartService from "@/laboratory/services/ChartService";
import {Widget} from "@/laboratory/components/dashboard/components/widget";
import {Pie} from "vue-chartjs";

const props = defineProps<{
    widget: PieChartWidget;
}>();

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    ArcElement,
);

const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '65%',
    radius: '100%',
    plugins: {
        tooltip: {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            titleColor: '#1f2937',
            bodyColor: '#1f2937',
            padding: 12,
            borderColor: 'rgba(0, 0, 0, 0.1)',
            borderWidth: 1
        }
    }
};

const chartData = computed(() => {
    return {
        labels: props.widget.data.labels,
        datasets: props.widget.data.datasets.map((dataset) => {
            return {
                data: dataset.values,
                backgroundColor: ChartService.colorPalette(),
                borderColor: "white",
                borderWidth: 2
            };
        })
    };
});
</script>

<template>
  <Widget :widget="widget">
    <Pie :options="options" :data="chartData" />
  </Widget>
</template>

<style scoped>

</style>
